import { Dialog, DialogContent, DialogTitle, Grid, Tooltip, } from "@mui/material";
import { useEffect, useState } from "react";
import { UpdateOrgSettings, getOrgSettings } from "../../actions/index";
import { CancelIcon, TwoFactorIcon, UnSubScribeLargeIcon } from "../../icon";
import { OrganizationModel } from "../../models/organization.model";
import { LoginType, LoginTypeModel, MapToLoginTypeModel, Setting, SettingsModel } from "../../models/settings-model";
import { SettingsService } from "../../services/SettingsService";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, ToasterTexts, ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import CustomSwitch from "../shared/switch.component";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";
import { OrganizationService } from "../../services/OrganizationService";

interface Props {
    onClose: () => void,
    settings: boolean,
    OrgId: string
}

const OrgSettings = (props: Props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const Organization: OrganizationModel[] = useSelector(selector.organizations);
    const Settings: Setting[] = useSelector(selector.settings);
    const settingobj: SettingsModel = useSelector(selector.settingsObj);


    const [show, setShow] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [setting, setSetting] = useState<string>('2fa');
    const [settings, setSettings] = useState<Setting[]>([]);
    const [organizationLoginType, setOrganizationLoginType] = useState<LoginTypeModel>({ SSOMandate: false, SSOType: LoginType.None })

    const [showDialogue, setShowDialogue] = useState<boolean>(false);
    const [ButtonName, setButtonName] = useState<string>("");
    const [switchType, setSwitchType] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedFeature, setSelectedFeature] = useState<any>(null);

    const hide = ["SATZ", "TFA", "WNA", "MPC", "MMC", "MGC", "BLCKMEDIA", "BLCKLINKS", "UNSUBSCRIBE", "MS", "LOWCRDT", "STAM", "PNFOM", "SIGN", "TMZ", "AI", "MSL", "KEYWORD"]


    useEffect(() => {
        if (!!props.OrgId) {
            getOrgSettings(dispatch, props.OrgId)
            OrganizationService.getOrganizationLoginType(props.OrgId).then((res) => {
                setOrganizationLoginType(MapToLoginTypeModel(res.data))
            }).catch((err) => { console.error("err", err) })
        }
    }, [])

    useEffect(() => {
        if (settings !== Settings) {
            setSettings(Settings)
        }
    }, [Settings])

    const onClose = () => {
        props.onClose();
    }


    // const handleManualInvoiceSwitch = (checked: boolean) => {
    //     if (!checked) {
    //         openConfirmDialog("manual");
    //     } else {
    //         let OrgName = props.Organization.find((x: OrganizationModel) => x.ID === props.OrgId)?.Name || ''
    //         let Setting = props.Settings.find(x => x.Code === SettingsService.MANUAL_INVOICE)
    //         props.UpdateOrgSettings(props.OrgId, { id: Setting?.ID, name: Setting?.Name, code: Setting?.Code, value: checked ? 'true' : 'false' }, ToasterTexts.ORG_MANUAL_INVOICE_ON.replace('<Name>', OrgName));
    //         // setToast(ToasterTexts. ORG_MANUAL_INVOICE_ON.replace('<Name>', OrgName), ToasterType.SUCCESS)
    //     }

    // }

    const closeConfirmDialog = (isConfirm: boolean) => {
        if (!!isConfirm) {
            setShow(false)
            let OrgName = Organization.find((x: OrganizationModel) => x.ID === props.OrgId)?.Name || ''
            let settingToDisable = setting === "teams" ? SettingsService.OUT_BOUND : setting === SettingsService.Unsubscribe_Organization_All_PhoneNumbers ? SettingsService.Unsubscribe_Organization_All_PhoneNumbers : SettingsService.Two_FactAuth_Code
            let Setting = Settings.find(x => x.Code === settingToDisable)
            let toasterMsg = setting === "teams" ? ToasterTexts.ORG_OUT_BOUND_TEAMS_OFF : setting === "2fa" ? ToasterTexts.ORG_TWO_FACTOR_AUTH_OFF : setting === SettingsService.Unsubscribe_Organization_All_PhoneNumbers ? ToasterTexts.UNSUBSCRIBE_ORG_ALL_PHONENUMBERS_DISABLE : ToasterTexts.ORG_MANUAL_INVOICE_OFF
            UpdateOrgSettings(dispatch, props.OrgId, { id: Setting?.ID, name: Setting?.Name, code: Setting?.Code, value: 'false' }, toasterMsg.replace('<Name>', OrgName));
            // setToast(setting === "teams" ? ToasterTexts.ORG_OUT_BOUND_TEAMS_OFF.replace('<Name>', OrgName) : ToasterTexts.ORG_TWO_FACTOR_AUTH_OFF.replace('<Name>', OrgName), ToasterType.SUCCESS);
        } else {
            setShow(false)
        }
    };

    const openConfirmDialog = (value: string) => {
        setShow(true)
        setSetting(value)
        setText(value === "teams" ? appNote.OUTBOUND_DISABLE_DISPLAY : value === "2fa" ? appNote.FACTOR_DISABLE_DISPLAY : value === SettingsService.Unsubscribe_Organization_All_PhoneNumbers ? appNote.UNSUBSCRIBE_DISABLE_MESSAGE : appNote.MANUAL_INVOICE_DISABLE_DISPLAY)
    }

    const gotoComplianceMSg = () => {
        let OrgId = Organization.find((x: OrganizationModel) => x.ID === props.OrgId)?.ID || ''
        let OrgRef = Organization.find((x: OrganizationModel) => x.ID === props.OrgId)?.Reference
        navigate(AppRoutes.COMPLIANCE_MESSAGE, { state: { organizationID: OrgId, orgreference: OrgRef }, })
    }

    const handleFeatureSwitch = (checked: boolean, type: string, feature?: any) => {
        let text = "";
        switch (type) {
            case SettingsService.Auto_Replay:
                text = checked
                    ? appNote.AUTO_REPALY_ENABLE_MESSAGE
                    : appNote.AUTO_REPALY_DISABLE_MESSAGE;
                break;
            case SettingsService.Group_Chat:
                text = checked
                    ? appNote.GROUP_CHAT_ENABLE_MESSAGE
                    : appNote.GROUP_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.MMS:
                text = checked
                    ? appNote.MMS_ENABLE_MESSAGE
                    : appNote.MMS_DISABLE_MESSAGE;
                break;
            case SettingsService.Schedule_Messages:
                text = checked
                    ? appNote.SCHEDULE_MESSAGES_ENABLE_MESSAGE
                    : appNote.SCHEDULE_MESSAGES_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_chat:
                text = checked
                    ? appNote.SECURE_CHAT_ENABLE_MESSAGE
                    : appNote.SECURE_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_File:
                text = checked
                    ? appNote.SECURE_FILE_ENABLE_MESSAGE
                    : appNote.SECURE_FILE_DISABLE_MESSAGE;
                break;
            case SettingsService.Transfer_Chat:
                text = checked
                    ? appNote.TRANSFER_CHAT_ENABLE_MESSAGE
                    : appNote.TRANSFER_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_Doc:
                text = checked
                    ? appNote.SECURE_DOC_ENABLE_MESSAGE
                    : appNote.SECURE_DOC_DISABLE_MESSAGE;
                break;
            case SettingsService.Keyword:
                text = checked
                    ? appNote.KEYWORD_REPLY_ENABLE_MESSAGE
                    : appNote.KEYWORD_REPLY_DISABLE_MESSAGE;
                break;
            case SettingsService.Unsubscribe_Organization_All_PhoneNumbers:
                text = checked
                    ? appNote.UNSUBSCRIBE_ENABLE_MESSAGE
                    : appNote.UNSUBSCRIBE_DISABLE_MESSAGE;
                break;
            case SettingsService.Two_FactAuth_Code:
                text = checked
                    ? appNote.FACTOR_ENABLE_DISPLAY
                    : appNote.FACTOR_DISABLE_DISPLAY;
                break;
            case SettingsService.OUT_BOUND:
                text = checked
                    ? appNote.OUTBOUND_ENABLE_DISPLAY
                    : appNote.OUTBOUND_DISABLE_DISPLAY;
                break;
            case SettingsService.OptInCollect:
                text = checked
                    ? appNote.OPTIN_COLLECT_ENABLE_MESSAGE
                    : appNote.OPTIN_COLLECT_DISABLE_MESSAGE;
                break;
            case SettingsService.Login_With_SSO_Only:
                text = checked
                    ? appNote.LOGIN_WITH_MICROSOFT_ONLY_ENABLE_MESSAGE
                    : appNote.LOGIN_WITH_MICROSOFT_ONLY_DISABLE_MESSAGE;
                break;
            case SettingsService.UnArchive:
                text = checked
                    ? appNote.ARCHIVED_ENABLE_MESSAGE
                    : appNote.ARCHIVED_DISABLE_MESSAGE;
                break;
            case SettingsService.Switch_PhoneNumber_Alert:
                text = checked
                    ? appNote.SWITCH_PHONENUMBER_ENABLE_MESSAGE
                    : appNote.SWITCH_PHONENUMBER_DISABLE_MESSAGE;
                break;
            case SettingsService.Clear_phonenumber_data:
                text = checked
                    ? appNote.CLEAR_PHONENUMBER_DATA_ENABLE_MESSAGE
                    : appNote.CLEAR_PHONENUMBER_DATA_DISABLE_MESSAGE;
                break;
            default:
                break;
        }
        openFeatureConfirmDialog(text, checked ? ActionLabels.ENABLE : ActionLabels.DISABLE, type, feature);
    }

    const openFeatureConfirmDialog = (text: any, action: string, type: string, feature?: any) => {
        setShowDialogue(true)
        setText(text)
        setButtonName(action)
        setSwitchType(type)
        setIsLoading(false)
        setSelectedFeature(feature)
    }

    const closeFeatureConfirmDialog = (isConfirm: boolean) => {
        let btnLabel = ButtonName;
        if (isConfirm) {
            if (switchType === SettingsService.Login_With_SSO_Only) {
                const data = { ssoType: btnLabel === ActionLabels.ENABLE ? LoginType.ONLY_MICROSOFT_LOGIN : LoginType.None, ssoMandate: btnLabel === ActionLabels.ENABLE }
                OrganizationService.updateOrganizationLoginType(props.OrgId, data).then((res) => {
                    setOrganizationLoginType(MapToLoginTypeModel(res.data))
                }).catch((err) => {

                })
            }
            else {
                let OrgName = Organization.find((x: OrganizationModel) => x.ID === props.OrgId)?.Name || ""
                let toasterMsg = selectedFeature?.Name + " " + btnLabel + " " + "successfully" + " " + "for " + OrgName;
                UpdateOrgSettings(dispatch, props.OrgId, {
                    id: selectedFeature?.ID,
                    name: selectedFeature?.Name,
                    code: selectedFeature?.Code,
                    value: btnLabel === ActionLabels.ENABLE ? "True" : "False",
                }, toasterMsg);
            }
            setShowDialogue(false)
        } else {
            setShowDialogue(false)
        }
        setShowDialogue(false)
    }

    return (
        <> {!IsMobileDevice ?
            <Dialog maxWidth='sm' BackdropProps={{ style: { backgroundColor: "transparent" } }} fullWidth={true} onClose={onClose} aria-labelledby="customized-dialog-title" open={props.settings && Settings.length > 0} classes={{ paper: "br-2 dialogue-shadow w-p-35" }} disableEscapeKeyDown>
                <DialogTitle className="dialog-header" id="customized-dialog-title">
                    <div className="h1-semibold color-display-title d-flex" id="customized-dialog-title">
                        {"Settings"}
                        <Tooltip title='Close' placement='bottom'><span className={"ml-auto"}><CancelIcon className={"c-pointer"} onClick={onClose} /></span></Tooltip>
                    </div>
                </DialogTitle>
                <div className={`bb-primary-divider-4`}></div>
                <DialogContent className="o-x-hidden p-0 mb-4">
                    <Grid container className="w-fill">
                        <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                            <span className="d-flex">
                                <TwoFactorIcon className={`w-4 mr-2 my-auto`} />
                                <p className={`h3-regular color-settings-items-heading`}>
                                    {ViewTextLabels.TWO_FACTOR_AUTHENTICATION}
                                </p>
                            </span>
                            <span className={`my-auto`}>
                                <CustomSwitch
                                    checked={settings.find(x => x.Code === SettingsService.Two_FactAuth_Code)?.Value.toString().toLowerCase() === "true"} onChange={(checked) => handleFeatureSwitch(checked, SettingsService.Two_FactAuth_Code, settings.find(x => x.Code === SettingsService.Two_FactAuth_Code))}
                                />
                            </span>
                        </Grid>
                        <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                            <span className="d-flex">
                                <TwoFactorIcon className={`w-4 mr-2 my-auto`} />
                                <p className={`h3-regular color-settings-items-heading`}>
                                    {ViewTextLabels.ENABLE_OUTBOUND}
                                </p>
                            </span>
                            <span className={`my-auto`}>
                                <CustomSwitch
                                    checked={settings.find(x => x.Code === SettingsService.OUT_BOUND)?.Value.toString().toLowerCase() === "true"} onChange={(checked) => handleFeatureSwitch(checked, SettingsService.OUT_BOUND, settings.find(x => x.Code === SettingsService.OUT_BOUND))}
                                />
                            </span>
                        </Grid>
                        <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                            <span className="d-flex">
                                <UnSubScribeLargeIcon className={`w-4 mr-2 my-auto`} />
                                <p className={`h3-regular color-settings-items-heading`}>
                                    {ViewTextLabels.ORG_WIDE_OPTOUT_POLICY}
                                </p>
                            </span>
                            <span className={`my-auto`}>
                                <CustomSwitch
                                    checked={settings.find(x => x.Code === SettingsService.Unsubscribe_Organization_All_PhoneNumbers)?.Value.toString().toLowerCase() === "true"} onChange={(checked) => handleFeatureSwitch(checked, SettingsService.Unsubscribe_Organization_All_PhoneNumbers, settings.find(x => x.Code === SettingsService.Unsubscribe_Organization_All_PhoneNumbers))}
                                />
                            </span>
                        </Grid>
                        <button className="w-fill" onClick={() => gotoComplianceMSg()}>
                            <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                                <span className="d-flex">
                                    <TwoFactorIcon className={`w-4 mr-2 my-auto`} />
                                    <p className={`h3-regular color-settings-items-heading t-decoration-underline`}>
                                        {"Compliance Message"}
                                    </p>
                                </span>
                            </Grid>
                        </button>

                        <div className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                            <Grid container>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <UnSubScribeLargeIcon className={`w-4 mr-2 my-auto`} />
                                    <p className={`h3-regular color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.LOGIN_WITH_MICROSOFT_ONLY}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto `}>
                                        <CustomSwitch
                                            checked={organizationLoginType?.SSOType === LoginType.ONLY_MICROSOFT_LOGIN}
                                            onChange={(checked: boolean) => handleFeatureSwitch(checked, SettingsService.Login_With_SSO_Only)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>

                        {
                            Settings.filter(x => !hide.includes(x.Code)).map((feature, index) => (
                                <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                                    <span className="d-flex">
                                        <UnSubScribeLargeIcon className={`w-4 mr-2 my-auto`} />
                                        <p className={`h3-regular color-settings-items-heading`}>
                                            {feature.Name}
                                        </p>
                                    </span>
                                    <span className={`my-auto`}>
                                        <CustomSwitch
                                            checked={feature.Value?.toString().toLowerCase() === "true"}
                                            onChange={(checked: boolean) => handleFeatureSwitch(checked, feature.Code, feature)}
                                        />
                                    </span>
                                </Grid>
                            ))
                        }

                        {/* <Grid item xs={12} className={`p-1 mx-auto d-flex justify-between bb-primary-divider-4 w-fill`}>
                            <span className="d-flex">
                                <TwoFactorIcon className={`w-4 mr-2 my-auto`} />
                                <p className={`h3-regular color-settings-items-heading`}>
                                    {ViewTextLabels.MANUAL_INVOICE}
                                </p>
                            </span>
                            <span className={`my-auto`}>
                                <CustomSwitch
                                    checked={settings.find(x => x.Code === SettingsService.MANUAL_INVOICE)?.Value.toString().toLowerCase() === "true"} onChange={handleManualInvoiceSwitch}
                                />
                            </span>
                        </Grid> */}
                    </Grid>
                </DialogContent >
            </Dialog > :
            <Grid container className={"bb-primary-divider-4 py-2"}>
                <Grid item xs={9} className={`pl-2 t-align-left d-flex `}>
                    <TwoFactorIcon className={` w-4 mr-2`} />
                    <p className={`h2 color-settings-items-heading t-align-left`}>
                        {ViewTextLabels.ENABLE_OUTBOUND}
                    </p>
                </Grid>
                <Grid item className={`b-none d-flex my-auto justify-center`} xs={3}>
                    <span className={`ml-auto mr-2`}>
                        <CustomSwitch
                            checked={settings.find(x => x.Code === SettingsService.Two_FactAuth_Code)?.Value.toString().toLowerCase() === "true"} onChange={(checked) => handleFeatureSwitch(checked, SettingsService.Two_FactAuth_Code, settings.find(x => x.Code === SettingsService.Two_FactAuth_Code))}
                        />
                    </span>
                </Grid>
            </Grid>
        }
            <ConfirmDialog onClose={closeConfirmDialog} Show={show} Text={text} ButtonName={buttonLabels.TURN_OFF.toUpperCase()}></ConfirmDialog>
            <ConfirmDialog onClose={closeFeatureConfirmDialog} Show={showDialogue} Text={text} ButtonName={ButtonName}></ConfirmDialog>

        </>
    )
}

export default OrgSettings;
